import {
  createMultiStyleConfigHelpers,
  mergeMultiStyleConfig,
  MultiStyleType,
  StyleThemingProps,
} from '~/utils/styleHelpers'

import { textStyleKeys } from '@mangovoice/design-system'
import { textStyles } from '@mangovoice/design-system'

const TabButtonParts = ['button', 'icon', 'text'] as const

const helpers = createMultiStyleConfigHelpers(TabButtonParts)
export const TabButtonStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    button: {
      flex: '1',
      height: '2.125rem',
      backgroundColor: 'bg.muted',
      borderRadius: '0.5rem',
      gap: '0.5rem',
      color: 'fg.default',
      _hover: {
        backgroundColor: 'bg.emphasized',
      },
      _active: {
        backgroundColor: 'bg.emphasized',
      },
      '&[data-active]': {
        backgroundColor: 'brand.solid',
        color: 'brand.contrast',
      },
    },
    icon: {
      boxSize: '1.125rem',
      color: 'fg.default',
    },
    text: {
      ...textStyles[textStyleKeys.Body2],
      color: 'fg.muted',
      _groupHover: {
        color: 'fg.default',
      },
      _groupActive: {
        color: 'fg.default',
      },
      '[data-active] &': {
        color: 'fg.default',
      },
    },
  },
})

export const useTabButtonStyle = (props?: StyleThemingProps) => {
  return mergeMultiStyleConfig(TabButtonStyle, props) as MultiStyleType<
    typeof TabButtonParts
  >
}
